/* eslint-disable react/prop-types */
import { Component } from "react";
import { Alert, Badge, Card, Spinner, Table } from "react-bootstrap";

import farmacovigilanciaConfigService from "../../api/atendimentos/farmacovigilanciaConfigService";
import { formataDataHoraExibicao } from "../../common/utils";

class FarmacovigilanciaAtendimento extends Component {
    constructor(props) {
        super(props);

        this.state = { loading: true, erro: "", dados: null };
    }

    componentDidMount() {
        this.carregar();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.atendimentoId !== this.props.atendimentoId) {
            this.carregar();
        }
    }

    carregar = async () => {
        const { atendimentoId } = this.props;

        if (!atendimentoId) {
            this.setState({ loading: false, dados: null });
            return;
        }

        this.setState({ loading: true, erro: "" });

        try {
            const response = await farmacovigilanciaConfigService.obterDoAtendimento(atendimentoId);
            this.setState({ loading: false, dados: response.data || null });
        } catch (error) {
            console.error("Erro ao carregar farmacovigilância:", error);
            const data = error?.response?.data;
            const primeiro = data && typeof data === "object" ? Object.values(data)[0] : null;
            this.setState({
                loading: false,
                erro: (Array.isArray(primeiro) ? primeiro[0] : primeiro) || "Não foi possível carregar a farmacovigilância.",
            });
        }
    };

    render() {
        const { loading, erro, dados } = this.state;

        if (loading) {
            return (
                <Card className="cardDestaque mt-4">
                    <Card.Body className="text-center">
                        <Spinner animation="border" size="sm" />
                    </Card.Body>
                </Card>
            );
        }

        if (erro) {
            return (
                <Alert variant="danger" className="mt-4">
                    {erro}
                </Alert>
            );
        }

        if (!dados) {
            return null;
        }

        const configuracao = dados.configuracao || {};
        const reportes = dados.reportes || [];
        const titulo = dados.nome_exibicao || "Farmacovigilância";

        if (!configuracao.habilitado) {
            return (
                <Card className="cardDestaque mt-4">
                    <Card.Body>
                        <h5 className="mb-1">{titulo}</h5>
                        <Alert variant="light" className="mb-0">
                            {dados.detalhe || "A Farmacovigilância não está habilitada para este programa."}
                        </Alert>
                    </Card.Body>
                </Card>
            );
        }

        return (
            <Card className="cardDestaque mt-4">
                <Card.Body>
                    <h5 className="mb-1">{titulo}</h5>
                    <small className="text-muted d-block mb-3">
                        Disponível neste programa via{" "}
                        {[
                            configuracao.preenchimento_plataforma && "preenchimento pela plataforma",
                            configuracao.download_pdf && "download do PDF",
                        ]
                            .filter(Boolean)
                            .join(" e ")}
                        .
                    </small>

                    <Table responsive className="custom-table table-sm align-middle mb-0">
                        <thead>
                            <tr>
                                <th>Reporte</th>
                                <th>Data</th>
                                <th>Situação</th>
                                <th>ID no cliente</th>
                                {configuracao.download_pdf && <th>PDF</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {reportes.length === 0 ? (
                                <tr>
                                    <td colSpan={configuracao.download_pdf ? 5 : 4} className="text-center">
                                        Nenhum reporte de farmacovigilância neste atendimento.
                                    </td>
                                </tr>
                            ) : (
                                reportes.map((reporte) => (
                                    <tr key={reporte.id}>
                                        <td>{reporte.titulo || `Reporte ${reporte.id}`}</td>
                                        <td>{reporte.data ? formataDataHoraExibicao(reporte.data) : "-"}</td>
                                        <td>
                                            <Badge bg={reporte.enviado ? "success" : "secondary"}>
                                                {reporte.enviado ? "Enviado" : "Pendente"}
                                            </Badge>
                                            {reporte.pdf_validado && (
                                                <Badge bg="info" className="ms-2">
                                                    PDF validado
                                                </Badge>
                                            )}
                                        </td>
                                        <td>{reporte.id_cliente || "-"}</td>
                                        {configuracao.download_pdf && (
                                            <td>
                                                {reporte.pdf_url ? (
                                                    <a href={reporte.pdf_url} target="_blank" rel="noreferrer">
                                                        Baixar PDF
                                                    </a>
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                        )}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        );
    }
}

export default FarmacovigilanciaAtendimento;
